module.exports = __webpack_public_path__ + "img/artboard.a2d13001.png";